import { CalendarDateIcon, Edit05Icon, Mail01Icon } from "@vetty/icons";
import { Button, Select, Tabs, TabsItem } from "@/components";
import {
  EMAIL_MAILBOX_OPTIONS,
  EMAIL_PERIOD_OPTIONS,
  EMAIL_TAB_ITEMS,
  type EmailMailboxFilter,
  type EmailPeriodFilter,
  type EmailToolbarTab,
} from "../../_constants/email-toolbar.const";
import styles from "./EmailToolbar.module.scss";

type EmailToolbarProps = {
  tab: EmailToolbarTab;
  period: EmailPeriodFilter;
  mailbox: EmailMailboxFilter;
  onTabChange: (value: EmailToolbarTab) => void;
  onPeriodChange: (value: EmailPeriodFilter) => void;
  onMailboxChange: (value: EmailMailboxFilter) => void;
  onComposeClick: () => void;
};

export const EmailToolbar = ({
  tab,
  period,
  mailbox,
  onTabChange,
  onPeriodChange,
  onMailboxChange,
  onComposeClick,
}: EmailToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Tabs
          value={tab}
          onChange={(value) => onTabChange(value as EmailToolbarTab)}
          variant="secondary"
          size="medium"
        >
          {EMAIL_TAB_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>

        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={period}
            startContent={<CalendarDateIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onPeriodChange(value as EmailPeriodFilter)}
          >
            {EMAIL_PERIOD_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={mailbox}
            startContent={<Mail01Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onMailboxChange(value as EmailMailboxFilter)}
          >
            {EMAIL_MAILBOX_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<Edit05Icon style={{ width: 20, height: 20 }} />}
          onClick={onComposeClick}
        >
          Compose
        </Button>
      </div>
    </div>
  );
};
